import {css, Global, ThemeProvider} from "@emotion/react";
import {SnackbarProvider} from "notistack";
import React from 'react';
import {BrowserRouter} from "react-router-dom";
import {ApiProvider} from "../../sdk/ApiProvider";
import {NavBar} from "../NavBar";
import {Routes} from "../Routes";
import {primaryTheme} from "../Themes";
import {useNotification} from "./hooks";
import {root} from "./styles";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import { Amplify } from 'aws-amplify';
import { Authenticator,useTheme,View,Image,Text } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

const defaultMessage = "Something went wrong";

//
// Styling for login here (TBD, put in a separate file)
//

const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Image
          alt="NS logo"
	  width="75%"
          src="https://nsdash.blob.core.windows.net/nsdashsignin/NS_Logo.svg"
        />
	<Text color={tokens.colors.neutral[100]} fontSize="20pt">
	  Coal Dust Monitoring Dashboard
	</Text>
	<Text color={tokens.colors.neutral[100]} fontSize="14pt">	
	  Operated by Simpson Weather Associates, Inc.
	</Text>
      </View>
    );
  },

  Footer() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large} width="200%" marginLeft="-50%">
	<Image
	  alt="SWA logo"
	  width="10%"
	  src="https://nsdash.blob.core.windows.net/nsdashsignin/logo_swa_2.png"
/><br/>
          <Text color={tokens.colors.neutral[100]} fontSize="9pt">
            For technical support, contact <a href="mailto:nsdashsupport@swa.com">nsdashsupport@swa.com</a>.<br/>
	    The information contained on this website is confidential. It is intended only for the use of authorized users. If the user of this website is not an authorized user, you are notified that any dissemination, distribution, or the use of the information contained herein is strictly prohibited. If you have reached this website by error, please leave this page immediately. All login sessions will be tracked. The use or reproduction of this website’s information without the advance written approval of Norfolk Southern Railway is prohibited.<br/>
      &copy; All Rights Reserved<br/>
          </Text>
      </View>
    );
  },
}

  export function App() {
    const {error: notifyError} = useNotification();

  return (
    <ApiProvider
      apiUrl={process.env.REACT_APP_API_URL || ""}
      apiKey={process.env.REACT_APP_API_KEY || "no-key"}
      onError={(errors, path) => {
        notifyError(defaultMessage);
        console.error("[ApiProvider] Failed fetching to", path, ":", errors)
      }}
    >

      <ThemeProvider theme={primaryTheme}>
        <Global styles={css`
          h1 {
          font-size: 25px;
          }

          h3 {
          font-size: 18px;
          }
        `}/>
	

        <ToastContainer/>
	<Authenticator variation="modal" hideSignUp={true}
	    components={components}>
          <div css={root}>
            <BrowserRouter>
              <NavBar>
		<Routes/>
              </NavBar>
            </BrowserRouter>
          </div>
	</Authenticator>

      </ThemeProvider>
    </ApiProvider>
  );
}
